function Bonaire({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_521_684)">
      <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
      <path d="M4.6863 4.68625C1.25724 8.11532 -0.289451 12.7137 0.0451116 17.1978L17.1978 0.0451268C12.7137 -0.289498 8.11537 1.25719 4.6863 4.68625V4.68625Z" fill="#FFDA44"/>
      <path d="M5.71313 28.2544C11.9994 33.5433 21.3969 33.2305 27.3138 27.3137C33.2306 21.3969 33.5434 11.9994 28.2545 5.71313L5.71313 28.2544Z" fill="#0052B4"/>
      <path d="M15.9429 15.3555L17.3217 14.6087L15.9429 13.8618C15.621 11.7705 13.9686 10.118 11.8773 9.79617L11.1303 8.4173L10.3835 9.79611C8.29221 10.118 6.63984 11.7704 6.31784 13.8617L4.93896 14.6087L6.31778 15.3555C6.63971 17.4469 8.29209 19.0993 10.3834 19.4212L11.1303 20.8L11.8772 19.4212C13.9686 19.0993 15.621 17.4469 15.9429 15.3555V15.3555ZM11.1304 17.3913C9.59359 17.3913 8.34778 16.1455 8.34778 14.6087C8.34778 13.0718 9.59353 11.826 11.1304 11.826C12.6673 11.826 13.913 13.0718 13.913 14.6087C13.913 16.1455 12.6672 17.3913 11.1304 17.3913Z" fill="black"/>
      <path d="M11.1304 12.5217L11.7329 13.5652H12.9378L12.3353 14.6087L12.9378 15.6522H11.7329L11.1304 16.6956L10.528 15.6522H9.32312L9.92556 14.6087L9.32312 13.5652H10.528L11.1304 12.5217Z" fill="#D80027"/>
    </g>
  </svg>

  `;

  return baseXml;
}

export default Bonaire;
